import React, { ReactNode, useContext } from 'react';
import { StyleProp, Text, TextStyle } from 'react-native';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  children,
  size = 'md',
  style = {},
  fontWeight = 'normal',
  onBrand = false,
}: {
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fontWeight?:
    | 'normal'
    | 'bold'
    | '100'
    | '200'
    | '300'
    | '400'
    | '500'
    | '600'
    | '700'
    | '800'
    | '900';
  style?: StyleProp<TextStyle>;
  onBrand?: boolean;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors, fontFamily, googleFont } = storeStates.designSystem;

  let fontSize = 16;
  switch (size) {
    case 'sm':
      fontSize = 14;
      break;
    case 'lg':
      fontSize = 18;
      break;
    case 'xl':
      fontSize = 20;
      break;
  }
  return (
    <Text
      style={[
        {
          color: onBrand ? colors.textOnBrand : colors.text,
          fontSize,
          fontWeight,
          fontFamily: googleFont ?? fontFamily,
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}
